<div class="ticket-body">
  <div class="w-100 px-4 d-flex justify-content-between align-items-end ticket-title">
    {{ 'Ticket' | translate }}
    <div class="ticket-number">{{ formatedTicketNumber }}</div>
  </div>
  <div class="w-100 progress-bar" [style.height.%]="percentageCompleted"></div>
  <div class="corner top-left"></div>
  <div class="corner top-right"></div>
  <div class="corner bottom-left"></div>
  <div class="corner bottom-right"></div>
</div>
